import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const i = t((o, a) => /* @__PURE__ */ e.jsx(
  r,
  {
    ref: a,
    ...o,
    image: (l) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M1 8a7 7 0 0 0 7 7h6a1 1 0 0 0 1-1V8A7 7 0 1 0 1 8m10 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
i.displayName = "ChatBubbleIcon";
export {
  i as ChatBubbleIcon,
  i as default
};
//# sourceMappingURL=index.js.map
